
import { useState } from 'react';
import { api } from '../config/api.ts';

export const useCoupon = () => {
  const [appliedCoupon, setAppliedCoupon] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const validateCoupon = async (code: string, amount: number) => {
    setLoading(true);
    try {
      const response = await api.post('/client/coupons/validate', {
        code,
        amount
      });
      
      if (response.data.success) {
        const couponData = {
          code: response.data.data.code,
          discount_type: response.data.data.discount_type,
          discount_value: response.data.data.discount_value,
          discount_amount: response.data.data.discount_amount
        };
        setAppliedCoupon(couponData);
        return couponData;
      }
    } catch (error: any) {
      setAppliedCoupon(null);
      throw new Error(error.response?.data?.message || 'فشل في تطبيق الكوبون');
    } finally {
      setLoading(false);
    }
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
  };

  return {
    appliedCoupon,
    loading,
    validateCoupon,
    removeCoupon
  };
};